// extracted by mini-css-extract-plugin
export default {"tabHead":"style--tabHead--d565a3"};